export default __webpack_public_path__ + "static/media/customer_placeholer.14d49407.svg";